<div class="duna-dashboard-admin">
  @if (!allowed) {
  <mat-card class="admin-card">
    <mat-card-content>Du har ikke adgang til dashboard-administration.</mat-card-content>
  </mat-card>
  } @else if (loading) {
  <p class="loading-text">Indlæser…</p>
  } @else if (editingLinkFilters) {
  <mat-card class="admin-card link-editor-card">
    <mat-card-header>
      <mat-card-title>Rediger filtre på link</mat-card-title>
      <mat-card-subtitle>{{ editingLinkFilters.label }}</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <app-duna-dashboard
        [shareLinkGuid]="editingLinkFilters.linkUuid"
        viewMode="shareLinkAdminFilters"
      ></app-duna-dashboard>
    </mat-card-content>
    <mat-card-actions align="end">
      <button mat-button (click)="closeLinkFilterEditor()">Luk</button>
    </mat-card-actions>
  </mat-card>
  } @else {
  <mat-card class="admin-card">
    <mat-card-header>
      <mat-card-title>Dashboard administration</mat-card-title>
      <mat-card-subtitle
        >Organisations- og DUNA-skabeloner, tildeling og delingslinks</mat-card-subtitle
      >
    </mat-card-header>
    <mat-card-content>
      <mat-tab-group (selectedIndexChange)="onAdminTabChange($event)">
        <mat-tab label="Skabeloner">
          <div class="tab-body tab-body--templates">
            <p class="section-hint templates-intro">
              Oversigt over DUNA- og organisations-skabeloner. Brug rediger (blyant) for navn,
              beskrivelse og <strong>flere målroller</strong>. Stjernen sætter standard inden for
              skabelonens roller.
            </p>
            <div class="table-panel">
            <table mat-table [dataSource]="templates" class="admin-table admin-table--templates">
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>Navn</th>
                <td mat-cell *matCellDef="let row">{{ row.name }}</td>
              </ng-container>
              <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef>Type</th>
                <td mat-cell *matCellDef="let row">
                  <span
                    class="type-badge"
                    [class.type-badge--duna]="row.isDunaTemplate"
                    >{{ row.isDunaTemplate ? 'DUNA' : 'Org' }}</span
                  >
                </td>
              </ng-container>
              <ng-container matColumnDef="targetRole">
                <th mat-header-cell *matHeaderCellDef>Rolle</th>
                <td mat-cell *matCellDef="let row">{{ templateRolesLabel(row) }}</td>
              </ng-container>
              <ng-container matColumnDef="widgets">
                <th mat-header-cell *matHeaderCellDef>Widgets</th>
                <td mat-cell *matCellDef="let row">{{ row.widgetCount ?? 0 }}</td>
              </ng-container>
              <ng-container matColumnDef="assigned">
                <th mat-header-cell *matHeaderCellDef>Brugere</th>
                <td mat-cell *matCellDef="let row">{{ row.assignedUserCount ?? 0 }}</td>
              </ng-container>
              <ng-container matColumnDef="links">
                <th mat-header-cell *matHeaderCellDef>Links</th>
                <td mat-cell *matCellDef="let row">{{ row.shareLinkCount ?? 0 }}</td>
              </ng-container>
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let row">
                  @if (canEditTemplateMeta(row)) {
                  <button mat-icon-button (click)="editTemplateMeta(row)" title="Rediger">
                    <mat-icon>edit</mat-icon>
                  </button>
                  } @if (canSetOrgDefault(row) || canSetPlatformDefault(row)) {
                  <button
                    mat-icon-button
                    (click)="onDefaultStarClick(row)"
                    [title]="defaultStarTitle(row)"
                  >
                    <mat-icon [class.org-default-star]="row.isDefault">{{
                      row.isDefault ? 'star' : 'star_border'
                    }}</mat-icon>
                  </button>
                  } @if (canToggleVisibility(row)) {
                  <button mat-icon-button (click)="toggleVisibility(row)" title="Synlighed">
                    <mat-icon>{{ row.isVisible ? 'visibility' : 'visibility_off' }}</mat-icon>
                  </button>
                  } @if (canDeleteTemplate(row)) {
                  <button mat-icon-button color="warn" (click)="deleteTemplate(row)" title="Slet">
                    <mat-icon>delete</mat-icon>
                  </button>
                  }
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="templateColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: templateColumns"></tr>
            </table>
            </div>
          </div>
        </mat-tab>

        <mat-tab label="Tildeling">
          <div class="tab-body">
            <mat-card class="info-card">
              <mat-card-content>
                <p>
                  <strong>Rolle</strong> er standard-dashboard for alle med den valgte rolle,
                  når de ikke har personlig tilpasning eller specifik bruger-tildeling.
                </p>
                <p>
                  <strong>Specifikke brugere</strong> overskriver rolle-fallback for de valgte
                  personer.
                </p>
                <p>
                  <strong>Stjerne</strong> (fanen Skabeloner) sætter standard <em>per målrolle</em> — én
                  pr. rolle for DUNA og én pr. rolle for org-skabeloner med samme målrolle.
                </p>
              </mat-card-content>
            </mat-card>

            <h3>Rolle-fallback: DUNA vs. organisation</h3>
            <p class="section-hint">
              Hvad brugere får via rolle, hvis de ikke har personligt valg eller specifik bruger-tildeling.
            </p>
            @if (loadingAssignmentOverview) {
            <p class="loading-text">Indlæser oversigt…</p>
            } @else {
            <table mat-table [dataSource]="roleFallbackOverview" class="admin-table overview-table">
              <ng-container matColumnDef="role">
                <th mat-header-cell *matHeaderCellDef>Rolle</th>
                <td mat-cell *matCellDef="let row">{{ roleLabel(row.role) }}</td>
              </ng-container>
              <ng-container matColumnDef="duna">
                <th mat-header-cell *matHeaderCellDef>DUNA</th>
                <td mat-cell *matCellDef="let row">{{ row.dunaTemplateName || '—' }}</td>
              </ng-container>
              <ng-container matColumnDef="org">
                <th mat-header-cell *matHeaderCellDef>Org</th>
                <td mat-cell *matCellDef="let row">
                  @if (row.orgTemplateName) {
                  {{ row.orgTemplateName }}
                  } @else {
                  <span class="muted">— (bruger DUNA)</span>
                  }
                </td>
              </ng-container>
              <ng-container matColumnDef="effective">
                <th mat-header-cell *matHeaderCellDef>Gælder i org</th>
                <td mat-cell *matCellDef="let row">
                  {{ row.effectiveTemplateName || '—' }}
                  @if (row.orgOverridesDuna) {
                  <span class="override-badge">Org override</span>
                  }
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="roleOverviewColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: roleOverviewColumns"></tr>
            </table>

            <h3>Bruger-tildelinger der afviger</h3>
            <p class="section-hint">
              Alle org-specifikke bruger-tildelinger sammenlignet med DUNA rolle-standard og med det der
              ellers ville gælde i org'en.
            </p>
            @if (!userAssignmentOverview.length) {
            <p class="empty-assignments">Ingen specifikke bruger-tildelinger i organisationen.</p>
            } @else {
            <table mat-table [dataSource]="userAssignmentOverview" class="admin-table overview-table">
              <ng-container matColumnDef="user">
                <th mat-header-cell *matHeaderCellDef>Bruger</th>
                <td mat-cell *matCellDef="let row">{{ row.name }}</td>
              </ng-container>
              <ng-container matColumnDef="userRole">
                <th mat-header-cell *matHeaderCellDef>Rolle</th>
                <td mat-cell *matCellDef="let row">{{ roleLabel(row.userRole) }}</td>
              </ng-container>
              <ng-container matColumnDef="assigned">
                <th mat-header-cell *matHeaderCellDef>Tildelt skabelon</th>
                <td mat-cell *matCellDef="let row">{{ row.assignedTemplateName }}</td>
              </ng-container>
              <ng-container matColumnDef="dunaFallback">
                <th mat-header-cell *matHeaderCellDef>DUNA rolle-standard</th>
                <td mat-cell *matCellDef="let row">{{ row.dunaRoleFallbackName || '—' }}</td>
              </ng-container>
              <ng-container matColumnDef="orgFallback">
                <th mat-header-cell *matHeaderCellDef>Org rolle-standard</th>
                <td mat-cell *matCellDef="let row">{{ row.orgRoleFallbackName || '—' }}</td>
              </ng-container>
              <ng-container matColumnDef="deviation">
                <th mat-header-cell *matHeaderCellDef>Afvigelse</th>
                <td mat-cell *matCellDef="let row">
                  @if (row.differsFromDunaRoleFallback) {
                  <span class="override-badge">≠ DUNA</span>
                  }
                  @if (row.differsFromEffectiveRoleFallback) {
                  <span class="override-badge">≠ rolle-fallback</span>
                  }
                  @if (!row.differsFromDunaRoleFallback && !row.differsFromEffectiveRoleFallback) {
                  <span class="muted">Matcher rolle-fallback</span>
                  }
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="userOverviewColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: userOverviewColumns"></tr>
            </table>
            }
            }

            <h3>Rediger tildeling for én skabelon</h3>
            <mat-form-field appearance="outline">
              <mat-label>Dashboard-skabelon</mat-label>
              <mat-select
                [(ngModel)]="selectedTemplateId"
                [compareWith]="compareTemplateId"
                (selectionChange)="onTemplateSelectionChange()"
              >
                @for (t of templates; track t.id) {
                <mat-option [value]="t.id"
                  >{{ t.name }} ({{ t.isDunaTemplate ? 'DUNA' : 'Org' }})</mat-option
                >
                }
              </mat-select>
            </mat-form-field>

            <h3>Målroller for skabelon</h3>
            <p class="section-hint">
              Vælg én eller flere roller, der skal bruge denne skabelon som rolle-fallback. Tom liste =
              alle roller.
            </p>
            <div class="role-row">
              <mat-form-field appearance="outline" class="roles-multi-field">
                <mat-label>Målroller</mat-label>
                <mat-select
                  [(ngModel)]="selectedTargetRoles"
                  multiple
                  [disabled]="!selectedTemplate || !canEditTemplateMeta(selectedTemplate)"
                >
                  <mat-option value="orgadmin">Organisationsadministrator</mat-option>
                  <mat-option value="uddansvarlig">Uddannelsesansvarlig</mat-option>
                  <mat-option value="orgbruger">Organisationsbruger</mat-option>
                </mat-select>
              </mat-form-field>
              <button
                mat-raised-button
                color="primary"
                [disabled]="savingRole || !selectedTemplateId || !selectedTemplate || !canEditTemplateMeta(selectedTemplate)"
                (click)="saveRoleAssignment()"
              >
                Gem roller
              </button>
            </div>

            <h3>Specifikke brugere</h3>
            <mat-form-field appearance="outline" class="search-field">
              <mat-label>Søg bruger</mat-label>
              <input
                matInput
                [(ngModel)]="assignmentSearch"
                (ngModelChange)="searchUsersForAssignment()"
              />
            </mat-form-field>

            @if (assignmentSearchResults.length) {
            <div class="search-results">
              @for (u of assignmentSearchResults; track u.userId) {
              <button mat-stroked-button type="button" (click)="addUserToAssignment(u)">
                {{ u.name }} @if (u.email) { ({{ u.email }}) }
              </button>
              }
            </div>
            }

            @if (assignedUsers.length) {
            <mat-chip-set aria-label="Tildelte brugere">
              @for (u of assignedUsers; track u.userId) {
              <mat-chip (removed)="removeAssignedUser(u.userId)">
                {{ u.name }}@if (u.email) { ({{ u.email }}) }
                <button matChipRemove aria-label="Fjern">
                  <mat-icon>cancel</mat-icon>
                </button>
              </mat-chip>
              }
            </mat-chip-set>
            } @else if (selectedTemplateId) {
            <p class="empty-assignments">Ingen brugere tildelt til denne skabelon endnu.</p>
            }

            <div class="toolbar">
              <button
                mat-raised-button
                color="primary"
                [disabled]="assigning || !selectedTemplateId"
                (click)="saveAssignments()"
              >
                Gem bruger-tildelinger
              </button>
            </div>
          </div>
        </mat-tab>

        <mat-tab label="Delingslinks">
          <div class="tab-body">
            <div class="create-link-row">
              <mat-form-field appearance="outline">
                <mat-label>Dashboard</mat-label>
                <mat-select [(ngModel)]="newLinkDashboardId">
                  @for (t of templates; track t.id) {
                  <mat-option [value]="t.id"
                    >{{ t.name }} ({{ t.isDunaTemplate ? 'DUNA' : 'Org' }})</mat-option
                  >
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Navn / modtager</mat-label>
                <input matInput [(ngModel)]="newLinkLabel" />
              </mat-form-field>
              <button
                mat-raised-button
                color="primary"
                [disabled]="creatingLink"
                (click)="createShareLink()"
              >
                Opret link
              </button>
            </div>

            <table mat-table [dataSource]="shareLinks" class="admin-table">
              <ng-container matColumnDef="label">
                <th mat-header-cell *matHeaderCellDef>Navn</th>
                <td mat-cell *matCellDef="let row">{{ row.label || '—' }}</td>
              </ng-container>
              <ng-container matColumnDef="dashboard">
                <th mat-header-cell *matHeaderCellDef>Dashboard</th>
                <td mat-cell *matCellDef="let row">{{ row.dashboardName }}</td>
              </ng-container>
              <ng-container matColumnDef="url">
                <th mat-header-cell *matHeaderCellDef>Link</th>
                <td mat-cell *matCellDef="let row">
                  <code class="link-snippet">{{ shareUrl(row.linkUuid) }}</code>
                </td>
              </ng-container>
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let row">
                  <button mat-icon-button (click)="copyShareUrl(row.linkUuid)" title="Kopier">
                    <mat-icon>content_copy</mat-icon>
                  </button>
                  <button mat-icon-button (click)="editLinkFilters(row)" title="Rediger filtre">
                    <mat-icon>tune</mat-icon>
                  </button>
                  <button mat-icon-button color="warn" (click)="deleteShareLink(row)" title="Slet">
                    <mat-icon>delete</mat-icon>
                  </button>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="linkColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: linkColumns"></tr>
            </table>
          </div>
        </mat-tab>
      </mat-tab-group>
    </mat-card-content>
  </mat-card>
  }
</div>
